import React, { useState, useEffect } from 'react';
import './BDCCategoriesList.scss';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../../config.js';
import { Loader } from '../../components/Loader/Loader.jsx';
import { BackButton } from '../../components/BackButton/BackButton.jsx';
import { ModalMessage } from '../../components/ModalMessage/ModalMessage.jsx';
import { Logout } from '../../components/Logout/Logout.jsx';
import { ReactSortable } from 'react-sortablejs';

export const BDCCategoriesList = () => {
	const [categoriesList, setCategoriesList] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);

	const getCategories = async () => {
		setLoading(true);
		try {
			const { data: response } = await Axios.get(`${API_URL}/bdc`);
			setCategoriesList(response.data);
		} catch (error) {
			console.log(error);
			setError(error.message);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getCategories();
	}, []);

	const deleteCategory = async (id) => {
		const confirm = window.confirm(
			'¿Estás seguro de que quieres eliminar la categoría (BDC)?'
		);
		if (!confirm) return;
		try {
			const { data: response } = await Axios.delete(
				`${API_URL}/bdc/${id}`
			);
			setMessage(response.message);
			getCategories();
		} catch (error) {
			console.log(error);
			setError(error.message);
		}
	};

	const handleSortUpdate = async (newOrder) => {
		const orderedIds = newOrder.map((item) => item._id);
		try {
			const { data: response } = await Axios.patch(
				`${API_URL}/bdc/order`,
				{ orderedIds },
				{ headers: { 'Content-Type': 'application/json' } }
			);
			setMessage(response.message);
		} catch (err) {
			console.error('❌ Error al actualizar orden:', err);
			setError('Error al actualizar el orden de las categorías BDC');
		}
	};

	return (
		<div className='BDCCategoriesList'>
			{loading && <Loader />}

			<div className='container'>
				<BackButton to='/dashboard' text='Dashboard' />
				<Logout />
				<br />
				<h3>CATEGORÍAS DE B.D.C.</h3>

				{message && (
					<ModalMessage
						type='success'
						message={message}
						onClose={() => setMessage(null)}
					/>
				)}
				{error && (
					<ModalMessage
						type='error'
						message={error}
						onClose={() => setError(null)}
					/>
				)}

				{categoriesList.length === 0 ? (
					<h4>No hay categorías todavía</h4>
				) : (
					<ReactSortable
						list={categoriesList}
						setList={setCategoriesList}
						ghostClass='dropArea'
						handle='.dragHandle'
						filter='.ignoreDrag'
						preventOnFilter={true}
						onEnd={({ oldIndex, newIndex }) => {
							if (oldIndex !== newIndex) {
								const newOrder = [...categoriesList];
								const [movedItem] = newOrder.splice(
									oldIndex,
									1
								);
								newOrder.splice(newIndex, 0, movedItem);
								setCategoriesList(newOrder);
								handleSortUpdate(newOrder);
							}
						}}
					>
						{categoriesList.map((bdcCategory) => (
							<div
								className='bdcCategory dragHandle'
								key={bdcCategory._id}
							>
								<h4>{bdcCategory.title}</h4>
								<div className='btn-container'>
									<Link
										className='editButton'
										to={`/edit-bdcCategory/${bdcCategory._id}`}
									>
										<img
											className='editIcon'
											src={require('../../assets/icons/editar.png')}
											alt='edit-icon'
										/>
									</Link>
									<button
										className='deleteButton'
										onClick={() =>
											deleteCategory(bdcCategory._id)
										}
									>
										X
									</button>
								</div>
							</div>
						))}
					</ReactSortable>
				)}
			</div>
		</div>
	);
};
